module.exports = __webpack_public_path__ + "static/media/combo_3.d938bfc5.png";